"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  useWindowDimensions: () => useWindowDimensions
});
module.exports = __toCommonJS(src_exports);
var import_constants = require("@tamagui/constants");
var import_react = require("react");
var import_react_native = require("react-native");
const initialValue = {
  fontScale: 1,
  height: 800,
  width: 600,
  scale: 1
};
function useWindowDimensions() {
  const current = (0, import_react_native.useWindowDimensions)();
  if (process.env.TAMAGUI_TARGET != "web")
    return current;
  const [state, setState] = (0, import_react.useState)(initialValue);
  (0, import_constants.useIsomorphicLayoutEffect)(() => {
    setState(current);
  }, [current.height, current.width, current.fontScale, current.scale]);
  return state;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  useWindowDimensions
});
//# sourceMappingURL=index.js.map
